import $ from 'jquery';
import {Status} from '../Config/Status.js';
import {Options} from '../Config/Options.js';
import Zipcode from "./Zipcode.js";


const showQuestion = ($this, scroll = true) => {
  $this.addClass(function() {
    const index = $('#js-entry .js-inquiry').index($this);
    $('#js-entry .js-step').attr('data-step', 5 - index);
    setTimeout(function() {

      $this.addClass(Options.actView);
      if(scroll) {
        let shift = $this.offset().top;
        if($('#js-entry .js-inquiry').index($this) > 0) {
          shift -= $('#js-entry .js-step').outerHeight() + $('#js-header').outerHeight()
        } else {
          shift = 0;
        }
        $('html,body').animate({scrollTop: shift}, 600);
      }
    },300)
    return Options.act;
  });
}


const checkFields = ($this, keyset) => {
  const parent = $this.closest('.js-inquiry');
  const index = $('#js-entry .js-inquiry').index(parent);
  const value = $this.val();
  const name = $this.attr('data-name');
  const fields = keyset[index];
  if(parent.find('[data-name="next"]')) {
    parent.find('[data-name="next"]').on('click', function() {
      showQuestion($('#js-entry .js-inquiry').eq(index+1));
    });
  }  
  if(fields[name].type === 'checkbox') {
    if($this.prop('checked')) {
      fields[name].value.push(value);
    } else {
      fields[name].value = fields[name].value.filter((item) => item !== value);
    }
  } else {
    if(name === 'zipcode' && value === '') {
      fields[name].value = '0000000';
    } else {
      fields[name].value = value;
    }
  }
  if(fields[name].type === 'radio' && !$this.attr('name')) {
    $('#js-entry [data-name="'+name+'"').not($this).prop('checked', false);
  }
  const checkbox = Object.keys(fields).map((key) => fields[key].type === 'checkbox').indexOf(true);
  const complete = Object.keys(fields).map((key) => typeof fields[key].value === 'object' ? fields[key].value.length > 0 : fields[key].value !== '').indexOf(false);
  const errors = Object.keys(fields).map((key) => fields[key].error).indexOf(true);
  if(parent[0] === $('#js-entry .js-inquiry').last()[0]) {
    if(complete === -1 && errors === -1) {
      $('#js-entry .js-step').attr('data-step', 0);
      $('#js-entry .js-submit').addClass(function() {
        $this = $(this);
        $('#js-entry').addClass('is-complete'); 
        setTimeout(function() {
          $this.addClass(Options.actView);
          $('html,body').animate({scrollTop: $('#js-entry .js-submit').offset().top - $('#js-entry .js-step').outerHeight() - $('#js-header').outerHeight()}, 600);
        },300);
        return Options.act;
      });
    }
  } else {
    if(checkbox > -1) {
      if(complete ===  -1 && errors === -1) {
        parent.find('[data-name="next"]').prop('disabled', false);
      } else {
        parent.find('[data-name="next"]').prop('disabled', true);
      }
    } else {
      if(complete ===  -1 && errors === -1) {
        showQuestion($('#js-entry .js-inquiry').eq(index+1));
      }
    }
  }
}

const Entry = () => {
  const params = new URLSearchParams(window.location.search);
  const query = params.get('q');
  const confirm = params.get('confirm');
  Zipcode();
  if(confirm) {
    $('#js-entry').addClass('is-complete'); 
    $('#js-entry .js-step').attr('data-step', 0);
    $('#js-entry .js-inquiry').addClass(`${Options.act} ${Options.actView}`);
    $('#js-entry .js-submit').addClass(`${Options.act} ${Options.actView}`);
    $('#js-entry .js-submit').find('button[data-name="submit"]').prop('disabled', false);
  } else {
    if(query) {
      if(query == 0) {
        $('#js-entry .js-autoCheck')[0].checked = true;
      } else if(query == 1){
        $('#js-entry .js-autoCheck')[1].checked = true;
      }
      showQuestion($('#js-entry .js-inquiry').eq(0));
      showQuestion($('#js-entry .js-inquiry').eq(1), false);
    } else {
      showQuestion($('#js-entry .js-inquiry').eq(0));
    }
  
    const keyset = []
    $('.js-inquiry').each(function() {
      const keys = {};
      $(this).find('input, select').each(function() {
        const validation = $(this).attr('data-validation') ? $(this).attr('data-validation') : false;
        const error = Boolean($(this).attr('data-validation'));
        if(Object.keys(keys).indexOf($(this).attr('data-name')) > -1) return;
        if($(this)[0].nodeName === 'SELECT') {
          keys[$(this).attr('data-name')] = {type: 'select', value: '', validation: validation, error: error};
        } else {
          if($(this).attr('type') === 'radio') {
            keys[$(this).attr('data-name')] = {type: 'radio', value: '', validation: validation, error: error};
          } else if($(this).attr('type') === 'checkbox') { 
            keys[$(this).attr('data-name')] = {type: 'checkbox', value: [], validation: validation, error: error};
          } else {
            if($(this).attr('data-name') === 'zipcode') {
            keys[$(this).attr('data-name')] = {type: 'text', value: '0000000', validation: false, error: false};
            } else {
              keys[$(this).attr('data-name')] = {type: 'text', value: '', validation: validation,error: error};
            }
          }
        }
      });
      keyset.push(keys);
    });
    
    $('#js-entry .js-inquiry').each(function() {
      $(this).find('input[type="checkbox"], input[type="radio"], select').on('change', function(e) {
        checkFields($(this), keyset);
      });
      $(this).find('input[type="text"], input[type="email"]').on('blur', function(e) {
        checkFields($(this), keyset);
      });
      $(this).find('input[type="text"], input[type="email"]').on('input', function() {
        const index = $('#js-entry .js-inquiry').index($(this).closest('.js-inquiry'));
        const name = $(this).attr('data-name');
        const value = $(this).val();
        const id = `Error_${name}`; 
        const html = `<p id="${id}">%message%</p>`;
        const label = $(this).attr('data-label');
        if(name !== 'zipcode') {
          if(value.replace(' ','').replace('　','') === '') {
            const message = label ? html.replace('%message%', label + 'を入力してください') : html.replace('%message%', '未入力です');
            $(this).closest('.js-field').find('.js-error').find(`#${id}`).remove();
            $(this).closest('.js-field').find('.js-error').append(message);
            keyset[index][name].error = true;
          } else {
            switch(keyset[index][name].validation) {
              case 'year': 
                if(!value.match(/^[0-9]{4}$/)) {
                  const message = html.replace('%message%', '西暦で入力してください');
                  $(this).closest('.js-field').find('.js-error').find(`#${id}`).remove();
                  $(this).closest('.js-field').find('.js-error').append(message);
                  keyset[index][name].error = true;
                } else {
                  $(this).closest('.js-field').find('.js-error').find(`#${id}`).remove();
                  keyset[index][name].error = false;
                }
              break;
              case 'kana':
                if(!value.match(/^[ァ-ヶー　]+$/)) {
                  const message = html.replace('%message%', '全角カタカナで入力してください');
                  $(this).closest('.js-field').find('.js-error').find(`#${id}`).remove();
                  $(this).closest('.js-field').find('.js-error').append(message);
                  keyset[index][name].error = true;
                } else {
                  $(this).closest('.js-field').find('.js-error').find(`#${id}`).remove();
                  keyset[index][name].error = false;
                }
              break;
              case 'tel':
                if(!value.match(/^[0-9]{2,4}[0-9]{2,4}[0-9]{3,4}$/)) {
                  const message = html.replace('%message%', '電話番号(ハイフンなし)の形式で入力してください');
                  $(this).closest('.js-field').find('.js-error').find(`#${id}`).remove();
                  $(this).closest('.js-field').find('.js-error').append(message);
                  keyset[index][name].error = true;
                } else {
                  $(this).closest('.js-field').find('.js-error').find(`#${id}`).remove();
                  keyset[index][name].error = false;
                }
              break;
              case 'email':
                if(!value.match(/^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/)) {
                  const message = html.replace('%message%', 'メールアドレスの形式で入力してください');
                  $(this).closest('.js-field').find('.js-error').find(`#${id}`).remove();
                  $(this).closest('.js-field').find('.js-error').append(message);
                  keyset[index][name].error = true;
                } else {
                  $(this).closest('.js-field').find('.js-error').find(`#${id}`).remove();
                  keyset[index][name].error = false;
                }
              break;
              default: 
                $(this).closest('.js-field').find('.js-error').find(`#${id}`).remove();
                keyset[index][name].error = false;
              break;
            }
          }
        }
      });
    });
  
    $('#js-entry [data-name="consent"]').on('change', function() {
      if($(this).prop('checked')) {
        $('#js-entry [data-name="submit"]').prop('disabled', false);
      } else {
        $('#js-entry [data-name="submit"]').prop('disabled', true);
      }
    });
  }
  $('#js-entry .js-form').submit(() => {
    history.replaceState('','','?confirm=1');
  });
}

export default Entry;